import { useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import {
    Modal,
    Button,
    Select,
    MenuItem,
    SelectChangeEvent,
    Checkbox,
    FormControlLabel,
} from "@mui/material";

interface ModalProps {
    open: boolean;
    handleClose: () => void;
}

export default function AddAdvisorPackage({ open, handleClose }: ModalProps) {
    const [sessionType, setSessionType] = useState("Video Call");
    const [recommended, setRecommended] = useState(false);

    const handleSessionTypeChange = (event: SelectChangeEvent) => {
        setSessionType(event.target.value);
    };

    return (
        <Modal className="modal rejectReason_modal" open={open} onClose={handleClose}>
            <div className="modal-dialog take_action_modal">
                <div className="modal-body">
                    {/* Header */}
                    <div className="modal_title">
                        <h2>Add Advisor Package</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={handleClose}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Form */}
                    <form className="form">
                        <div className="gap_p">
                            {/* Package Key */}
                            <div className="control_group w_50">
                                <label htmlFor="package-key">Package Key</label>
                                <TextField
                                    placeholder="Enter Package Key"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "package-key" }}
                                />
                            </div>

                            {/* Session Type */}
                            <div className="control_group w_50">
                                <label htmlFor="session-type">Session Type</label>
                                <Select
                                    fullWidth
                                    value={sessionType}
                                    onChange={handleSessionTypeChange}
                                    inputProps={{ id: "session-type" }}
                                >
                                    <MenuItem value="Video Call">Video Call</MenuItem>
                                    <MenuItem value="Voice Call">Voice Call</MenuItem>
                                    <MenuItem value="Chat">Chat</MenuItem>
                                </Select>
                            </div>

                            {/* Name EN */}
                            <div className="control_group w_50">
                                <label htmlFor="name-en">Name (EN)</label>
                                <TextField
                                    placeholder="Enter Name (EN)"
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "name-en" }}
                                />
                            </div>

                            {/* Name AR */}
                            <div className="control_group w_50">
                                <label htmlFor="name-ar">Name (AR)</label>
                                <TextField
                                    placeholder="Enter Name (AR)"
                                    fullWidth
                                    hiddenLabel
                                    dir="rtl"
                                    inputProps={{ id: "name-ar" }}
                                />
                            </div>

                            {/* Duration */}
                            <div className="control_group w_50">
                                <label htmlFor="duration-min">Duration (min)</label>
                                <TextField
                                    type="number"
                                    defaultValue={30}
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "duration-min" }}
                                />
                            </div>

                            {/* Price */}
                            <div className="control_group w_50">
                                <label htmlFor="price-aed">Price (AED)</label>
                                <TextField
                                    type="number"
                                    defaultValue={0}
                                    fullWidth
                                    hiddenLabel
                                    inputProps={{ id: "price-aed" }}
                                />
                            </div>

                            {/* Description */}
                            <div className="control_group w_100">
                                <label htmlFor="description">Description</label>
                                <TextField
                                    placeholder="Enter description"
                                    fullWidth
                                    hiddenLabel
                                    multiline
                                    rows={3}
                                    inputProps={{ id: "description" }}
                                />
                            </div>

                            {/* Recommended checkbox */}
                            <div className="control_group w_100">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={recommended}
                                            onChange={(e) => setRecommended(e.target.checked)}
                                        />
                                    }
                                    label="Mark as recommended"
                                />
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="footer_btn_flex">
                            <Button
                                className="btn btn_grey"
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                            <Button
                                className="btn btn_primary"
                                onClick={handleClose}
                            >
                                Save
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}
